import styled from '@emotion/styled';
import { FolderOffOutlined } from '@mui/icons-material';
import Theme from 'App.theme';

export const Container = styled.div`
  display: flex;
  min-height: 300px;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export const FolderOffOutlinedStyled = styled(FolderOffOutlined)`
  color: ${Theme.greys.GREY4};
  padding-right: 10px;
`;
